import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskOrTemplatePayload } from '../../../utils'
import { TaskAssigneesAutocomplete } from '../detailed-forms'
import { TaskFormField } from '../TaskFormField'

export const TaskAssigneesField = () => {
    const { t: translate } = useTranslation()
    const { control } = useFormContext<TaskOrTemplatePayload>()

    return (
        <Controller
            control={control}
            name='assignees'
            render={({ field }) => (
                <TaskFormField
                    label={translate('form.assignees.label', { ns: 'tasks' })}
                    className='mb-3'
                >
                    <TaskAssigneesAutocomplete
                        value={field.value || []}
                        onChange={field.onChange}
                    />
                </TaskFormField>
            )}
        />
    )
}
